<template>
  <div class="header">
    <p class="header-logo">
      <router-link :to="{ name: '選擇頁' }">
        <img src="~@/assets/img/svg/logo.svg" alt="" />
      </router-link>
    </p>
    <ul class="header-menu">
      <li>
        <router-link :to="{ name: '銷售' }" active-class="active">
          銷售
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: '課程點名' }" active-class="active">
          課程點名
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: '會員註冊' }" active-class="active">
          會員註冊
        </router-link>
      </li>
    </ul>

    <div class="header-user">
      <div class="header-user-text">
        <p>{{ branchName }} {{ `${name} (${account})` }}</p>
        <p class="click-branch">{{ showBranchClickName }}</p>
      </div>
      <a href="#" @click.prevent="$bvModal.show('member-logout')">
        <span class="icon-icon_longout"></span>
      </a>
    </div>
    <MemberLogout />
  </div>
</template>

<script>
import MemberLogout from '@/components/Modal/MemberLogout';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  components: {
    MemberLogout
  },
  computed: {
    ...mapState('user', ['userClickBranch']),
    ...mapGetters('user', ['isLogin', 'name', 'branchName', 'account']),
    showBranchClickName() {
      return this.userClickBranch ? `銷售分店：${this.userClickBranch}` : '';
    }
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(['fetchInitialData'])
  },
  created() {
    if (this.isLogin) {
      this.fetchInitialData();
    }
  }
};
</script>

<style lang="scss"></style>
